// Texts for actions that wait until the Chamber Set Up page has no unsaved
// changes (Wave 3 IN-062, EM-055). "Save Changes" and "Reset" are the
// SectionSaveReset button labels.
const UNSAVED_CHANGES_FIRST =
  "You have unsaved changes on this page. Select Save Changes or Reset in that section first.";

export const UNSAVED_BEFORE_STRIPE_TEXT = `${UNSAVED_CHANGES_FIRST} Then try the Credit Card setting again.`;

export const UNSAVED_BEFORE_EMAIL_DOMAIN_TEXT = `${UNSAVED_CHANGES_FIRST} Then come back to Email Domain Set Up.`;
